import { Button } from "@mui/material";
import { AccessTime, NotificationsOffOutlined } from "@mui/icons-material";
import { H6, Body2, Body3, Body1 } from "../../../../../themes/typography";

export default function SystemAlerts() {
    const demoAlerts = [
        {
            title: "New feature rollout: Advanced analytics",
            description: "We’re releasing Advanced analytics on Nov 12, 2025."
        },
        {
            title: "Incident resolved: Email delivery delays",
            description: "Between 08:10–09:05 UTC on Nov 6, 2025, some emails were delayed."
        },
        {
            title: "Planned maintenance on Nov 9, 2025",
            description: "The platform will be unavailable from 01:00–02:30 UTC for database upgrades."
        }
    ];

    // const demoAlerts = [];

    const hasAlerts = demoAlerts && demoAlerts.length > 0;

    return (
        <div className="event-system-alerts-container">
            <div className="event-system-alert-wrapper">

                {/* Header */}
                <div className="event-system-alert-title">
                    <H6 fontWeight={600}>System Alerts</H6>
                </div>

                {/* Alert List / Empty State */}
                <div className="event-system-alert-list">
                    {hasAlerts ? (
                        demoAlerts.map((alert, index) => (
                            <div className="each-system-alert-item" key={index}>
                                <div className="system-alert-item-icon">
                                    <AccessTime color="tertiary" />
                                </div>

                                <div className="system-alert-item-content">
                                    <div className="system-alert-item-message">
                                        <div className="systemalert-item-title">
                                            <Body2 fontWeight={400}>
                                                {alert.title}
                                            </Body2>
                                        </div>
                                        <div className="systemalert-item-description">
                                            <Body3>{alert.description}</Body3>
                                        </div>
                                    </div>
                                    <div className="system-alert-item-action">
                                        <Button
                                            variant="text"
                                            size="small"
                                            disableTouchRipple
                                            sx={{ padding: 0, fontSize: "1rem" }}
                                        >
                                            Learn more
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="no-system-alerts">
                            <div className="no-system-alerts-icon">
                                <NotificationsOffOutlined sx={{ fontSize: "3rem" }} color="inherit" />
                            </div>
                            <Body1 fontWeight={400}>
                                No system alerts at the moment
                            </Body1>
                            <Body2 color="var(--secondary-color)" fontWeight={350}>
                                You’re all caught up! We’ll notify you of any new updates.
                            </Body2>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}